"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = exports.StyledNumberInputBox = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
exports.StyledNumberInputBox = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 36px;\n    font-size: ", ";\n    color: ", ";\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: ", ";\n    resize: none;\n    border: 1px solid ", ";\n    background-color: white;\n\n    &[disabled] {\n        opacity: ", ";\n    }\n"], ["\n    width: 100%;\n    height: 36px;\n    font-size: ", ";\n    color: ", ";\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: ", ";\n    resize: none;\n    border: 1px solid ", ";\n    background-color: white;\n\n    &[disabled] {\n        opacity: ", ";\n    }\n"])), Theme_1.FontSize, Theme_1.Color.Grey.G80, Theme_1.PixelUnit(1), Theme_1.Color.Grey.G30, Theme_1.DisabledOpacity);
var NumberInput = /** @class */ (function (_super) {
    __extends(NumberInput, _super);
    function NumberInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            _this.setState({ Value: e.target.value }, function () {
                _this.props.OnChange(_this.props.DecimalPlaces ?
                    parseFloat(parseFloat(_this.state.Value).toFixed(_this.props.DecimalPlaces)) :
                    parseInt(_this.state.Value, 10));
            });
        };
        _this.setValuefromProps = function (props) {
            if (props.Value !== undefined && props.Value !== null) {
                return { Value: _this.getValue(props.Value).toString() };
            }
            else {
                return { Value: "" };
            }
        };
        _this.handleOnBlur = function (e) {
            e.target.value = _this.getValue(Number(e.target.value)).toString();
            _this.handleChange(e);
        };
        _this.getValue = function (value) {
            var inputValue = value;
            if (_this.props.Min !== null && _this.props.Min !== undefined && inputValue < _this.props.Min) {
                inputValue = _this.props.Min;
            }
            if (_this.props.Max !== null && _this.props.Max !== undefined && inputValue > _this.props.Max) {
                inputValue = _this.props.Max;
            }
            return inputValue;
        };
        _this.state = _this.setValuefromProps(props);
        return _this;
    }
    NumberInput.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState(__assign({}, this.setValuefromProps(props)));
    };
    NumberInput.prototype.render = function () {
        return (React.createElement(exports.StyledNumberInputBox, { id: this.props.ID, placeholder: this.props.Placeholder, onChange: this.handleChange, onBlur: this.handleOnBlur, type: "number", style: { width: this.props.Width }, value: this.state.Value, disabled: this.props.Disabled, readOnly: this.props.ReadOnly, "aria-label": this.props.AriaLabel, min: this.props.Min, max: this.props.Max }));
    };
    return NumberInput;
}(React.Component));
exports.NumberInput = NumberInput;
var templateObject_1;
